// Ported from packages/desk/src/mobile/store.ts (docs/PLAN-2026-09-21-mobile-os-shell.md, step 4). Same file name and props
// as the desk copy, the dk- prefix renamed rdr-, so a fix in one is a copy in the other. Radar never imports @gamo/desk.
/**
 * Which sheet the phone home screen shows (the App Library, Search or Profile), in a tiny external store so a host can
 * open one from outside the desk: a guided tour opens the App Library to point at it. At most one sheet at a time; an
 * app opening closes it.
 */
import { useSyncExternalStore } from "react";
import { closeWindow, getState } from "../store";

export type MobileSheetKind = "library" | "search" | "profile";

let sheet: MobileSheetKind | null = null;
const listeners = new Set<() => void>();

function set(next: MobileSheetKind | null): void {
  if (next === sheet) return;
  sheet = next;
  for (const fn of listeners) fn();
}

export function openMobileSheet(kind: MobileSheetKind): void {
  set(kind);
}

export function closeMobileSheet(): void {
  set(null);
}

export function getMobileSheet(): MobileSheetKind | null {
  return sheet;
}

/** Back to the home screen: every sheet and every opened app closed. */
export function goHome(): void {
  set(null);
  for (const id of Object.keys(getState().windows)) closeWindow(id);
}

export function useMobileSheet(): MobileSheetKind | null {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => sheet,
    () => sheet,
  );
}
